<template>
  <section class="boxes">
    <div class="index-content" id="selected_item">
      <b-row class="centered-block">
        <b-col lg="10" xs="12">
          <div class="form-fields">
            <b-row v-if="inputType" class="justify-content-md-center" :class="{'pt-4': session.is_legacy}">
              <b-col v-if="selectOptions && selectOptions.length" :md="10" :class="{'pt-0 new-radio-group': !session.is_legacy}">
                <template v-if="isRadioGroup || isRadioOrSelect">
                  <div class="choice-fields-input">
                    <b-form-group label-for="radio-group" :label="label" :class="{'d-none': isRadioOrSelect, 'd-md-block': isRadioOrSelect}">
                      <b-form-radio-group id="radio-group" v-model="selectedInput" name="radio-group" @change="radioGroupValueChanged" stacked>
                        <b-form-radio v-for="option in selectOptions" :key="option.value.id" :value="option.value"
                                      :class="{'selected': option.value === selectedInput}" :for="'option-'+option.value.id"
                                      :id="'option-'+option.value.id">
                          <div><span v-html="option.text"></span><span v-if="option.isCurrent"> (current)</span></div>
                        </b-form-radio>
                      </b-form-radio-group>
                    </b-form-group>
                  </div>
                </template>
                <template v-if="isSelect || isRadioOrSelect">
                  <div class="choice-fields-input">
                  <b-form-group label-for="select-group" :label="label" :class="{'d-md-none': isRadioOrSelect}">
                    <b-form-select id="select-group" v-model="selectedInput">
                      <option :value="null"> --- Please Select --- </option>
                      <option v-for="option in selectOptions" :key="option.value.id" :value="option.value">
                        <div><span v-html="option.text"></span><span v-if="option.isCurrent"> (current)</span></div>
                      </option>
                    </b-form-select>
                  </b-form-group>
                  </div>
                </template>
              </b-col>
              <b-col class="p-0" md="5" v-for="(field, index) in additionalFields" :key="'input-data-field-' + index.toString()">
                <InputField :input="selectedInput" :field="field" :default="inputData[field.name]"></InputField>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
      <b-row class="centered-block">
        <b-col lg="10" xs="12">
          <b-row>
            <b-col lg="10" xs="12" class="choice-fields-btns">
              <!-- Confirm Button //surveys -->
              <button v-if="buttonLabel" type="button" @click="submitForm()" :disabled="!selectedInput"
                        class="btn-base input-choice-btn mt-0" :style="buttonStyles && buttonStyles.style">
                <span v-html="buttonLabel"></span>
              </button>

              <!-- Confirm & Reject Buttons -->
              <InputButton
                v-for="input in additionalInputs"
                :key="'choice-' + input.id"
                :input="input"
                @click="selectInput(input)"
              ></InputButton>

              <!-- Back Button // surveys : in case allow_undo = true -->
              <template v-if="canUndo">
                <button @click="goBack()" type="button" class="btn-base new-btn-back new-btn-outline-success mt-0">
                  <span>Back</span>
                </button>
              </template>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </div>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import {InputType} from '@/constants'
import {updateFontSizes} from '@/utils'
const InputField = () => import('@/components/InputField')
const InputButton = () => import('@/components/InputButton')

export default {
  name: 'ChoiceFields',
  components: {
    InputField,
    InputButton
  },
  data: function() {
    return {
      inputType: null,
      selectedInput: null,
      selectOptions: [],
      inputData: {},
      label: null,
      additionalFields: [],
      additionalInputs: [],
      buttonLabel: null,
      buttonStyles: '',
      showDropdownOptions: false
    }
  },
  computed: {
    ...mapState(['session']),
    isRadioGroup: function() {
      return (this.inputType === InputType.Radio)
    },
    isSelect: function() {
      return (this.inputType === InputType.Select)
    },
    isRadioOrSelect: function() {
      return (this.inputType === InputType.RadioSelect)
    },
    canUndo: function() {
      return this.session && (this.session.can_undo || this.session.is_step_preview)
    }
  },
  methods: {
    onClickOutside() {
      this.showDropdownOptions = false
    },
    updateData: function(field, val) {
      this.inputData[field] = val
    },
    selectInput: function(input) {
      this.$emit('submit', input)
    },
    submitForm: function() {
      if (this.selectedInput) {
        this.$emit('submit', this.selectedInput, this.inputData)
      }
    },
    goBack: function() {
      this.$emit('back')
    },
    radioGroupValueChanged: function(data) {
      if ('billing_interval_days' in data.input_fields && 'next_bill_date' in data.input_fields) {
        let billingIntervalDays = data.input_fields.billing_interval_days.value
        let updatedBillDate = new Date()
        updatedBillDate.setDate(updatedBillDate.getDate() + billingIntervalDays)
        updatedBillDate = updatedBillDate.getFullYear() + '-' + (updatedBillDate.getMonth() + 1) + '-' +
          updatedBillDate.getDate()

        this.inputData['next_bill_date'] = updatedBillDate
        const tempAdditionalFields = this.additionalFields.slice()
        this.additionalFields = []
        tempAdditionalFields.forEach(field => {
          if (field.name === 'next_bill_date') {
            field.max = updatedBillDate
          }
        })
        const _this = this
        setTimeout(() => { _this.additionalFields = tempAdditionalFields }, 0)
      }
    }
  },
  created: function() {
    if (this.session.valid_inputs.length >= 1) {
      const firstInput = this.session.valid_inputs[0]
      this.inputType = firstInput.type

      // get the additional input fields
      if (firstInput.input_fields) {
        const fields = Object.entries(firstInput.input_fields)
        for (const [key, field] of fields) {
          // ignore the billing_interval_days because we are doing it as radio button
          if (key !== 'billing_interval_days') {
            this.additionalFields.push(Object.assign({name: key}, field))
          }

          if (field.default) {
            this.inputData[key] = field.default
          } else if (this.session.selected_item && (key in this.session.selected_item)) {
            this.inputData[key] = this.session.selected_item[key]
          }
        }
      }

      if (this.session.valid_inputs.length === 1) {
        // if there's only 1 valid input, select it by default
        this.selectedInput = firstInput
      } else {
        let isBillingIntervalSelection = false
        this.selectedInput = null

        // multiple inputs - get the choices
        for (let input of this.session.valid_inputs) {
          if ([InputType.Radio, InputType.Select, InputType.RadioSelect].indexOf(input.type) !== -1) {
            let label = input.formatted_label
            let sortVal = 0 // value used for sorting the options (only used for billing interval selection)
            let isCurrentSelection = false

            if (this.session.selected_item &&
              input.input_fields &&
              ('billing_interval_days' in input.input_fields) // if this is a billing interval selection option
            ) {
              // hack to get default input and label for billing interval input
              // should remove this later once we properly implement forms
              const field = input.input_fields.billing_interval_days
              isBillingIntervalSelection = true

              if ('billing_interval_days' in this.inputData) {
                delete this.inputData['billing_interval_days'] // this is the input field, so don't include in input data
              }

              if (('type' in field) &&
                ('value' in field) &&
                (field.type === InputType.Hidden)) {
                sortVal = field.value // we'll sort the options by billing interval days

                if (field.value === null || field.value === this.session.selected_item.billing_interval_days) {
                  if (this.selectedInput) {
                    continue // null value and value == current setting is the same thing, so avoid duplicate options
                  }

                  this.selectedInput = input
                  isCurrentSelection = true
                  sortVal = this.session.selected_item.billing_interval_days // we set this since field.value can be null
                }
              }
            }

            this.selectOptions.push({value: input, text: label, sortVal: sortVal, isCurrent: isCurrentSelection})
          } else {
            this.additionalInputs.push(input)
          }
        }

        if (isBillingIntervalSelection) {
          this.selectOptions.sort(function(a, b) {
            return a.sortVal - b.sortVal
          })
        }
      }
    }

    this.buttonLabel = this.additionalFields.length ? 'Save' : 'Continue'

    // label coming from the session takes precedence
    const buttonStyles = this.session.button_styles
    if (buttonStyles) {
      if (buttonStyles.confirm) {
        this.buttonLabel = updateFontSizes(buttonStyles.confirm.label)
        this.buttonStyles = buttonStyles.confirm
      }
    }
  }
}
</script>

<style scoped lang="less">
  .choice-fields-btns {
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-width: 550px;
    margin: auto;

    button {
      width: 100%;
      min-height: 51px;
    }
  }

  .choice-fields-col {
    padding: 0;
  }

  @media only screen and (min-width: 415px) and (max-width: 768px) {
    .choice-fields-col {
      padding: 0 12px;
    }
  }
</style>
